import { render, staticRenderFns } from "./SalesDetails.vue?vue&type=template&id=7adb74a6&scoped=true&"
import script from "./SalesDetails.vue?vue&type=script&lang=js&"
export * from "./SalesDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesDetails.vue?vue&type=style&index=0&id=7adb74a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adb74a6",
  null
  
)

export default component.exports